<template>
   <div class="card flex flex-col bg-white rounded-lg shadow hover:shadow-xl transition-shadow duration-200">
            <div class="profile border-4 border-white mx-auto h-24 w-24 rounded-full overflow-hidden transform -translate-y-12 shadow-lg">
              <img
                v-if="avatar"
                :src="`https://cpanel.awronore.krd${avatar}`"
                alt
                class="w-full h-full object-cover"
              />
            </div>
            <div class="body flex-1 flex flex-col justify-between -mt-10 text-center">
              <div class="content mb-4 p-4">
                <head-line :level="3" :size="5" :bold="false" class="mb-2">{{ FullName }} </head-line>

                <p class="text-muted text-gray-600 mb-6 flex items-center justify-center">
                  <svg
                    class="text-awro-700 fill-current mr-2"
                    width="18"
                    height="18"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 201.324 201.324"
                    style="enable-background:new 0 0 201.324 201.324;"
                    xml:space="preserve"
                  >
                    <circle cx="95.596" cy="10.083" r="10.083" />
                    <circle cx="149.018" cy="10.083" r="10.083" />
                    <path
                      d="M179.06,19.254c-5.123-8.873-14.298-14.17-24.544-14.17v10c6.631,0,12.568,3.428,15.884,9.17
                        c3.316,5.743,3.316,12.599,0.001,18.342l-32.122,55.636c-3.315,5.742-9.253,9.17-15.884,9.171c-6.631,0-12.569-3.428-15.885-9.171
                        L74.389,42.595c-3.315-5.742-3.315-12.599,0-18.341s9.254-9.171,15.885-9.171v-10c-10.246,0-19.422,5.297-24.545,14.171
                        s-5.123,19.468,0,28.341l32.121,55.636c4.272,7.399,11.366,12.299,19.545,13.727v26.832c0,26.211-15.473,47.535-34.492,47.535
                        c-19.019,0-34.491-21.324-34.491-47.535v-31.948C59.802,109.52,68.4,99.424,68.4,87.356c0-13.779-11.21-24.989-24.989-24.989
                        s-24.989,11.21-24.989,24.989c0,12.067,8.598,22.163,19.989,24.486v31.948c0,31.725,19.959,57.535,44.492,57.535
                        c24.532,0,44.491-25.81,44.491-57.535v-26.832c8.178-1.428,15.273-6.328,19.544-13.727l32.122-55.636
                        C184.184,38.722,184.184,28.127,179.06,19.254z"
                    />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                  </svg>

                  <span class="text-sm text-awro-600">{{ speciality }}</span>
                </p>

                <p class="text-gray-500 text-sm flex mt-8 items-start justify-center">
                  <svg
                    class="text-awro-700 fill-current mr-1"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.64 16.36C4.38021 15.1018 3.52193 13.4981 3.17376 11.752C2.82558 10.0059 3.00316 8.19569 3.68402 6.5505C4.36488 4.90531 5.51842 3.49904 6.99871 2.50962C8.47899 1.52019 10.2195 0.992065 12 0.992065C13.7805 0.992065 15.521 1.52019 17.0013 2.50962C18.4816 3.49904 19.6351 4.90531 20.316 6.5505C20.9968 8.19569 21.1744 10.0059 20.8263 11.752C20.4781 13.4981 19.6198 15.1018 18.36 16.36L12.71 22.02C12.617 22.1137 12.5064 22.1881 12.3846 22.2389C12.2627 22.2896 12.132 22.3158 12 22.3158C11.868 22.3158 11.7373 22.2896 11.6154 22.2389C11.4936 22.1881 11.383 22.1137 11.29 22.02L5.64 16.36ZM16.95 14.95C17.9289 13.971 18.5955 12.7237 18.8656 11.3659C19.1356 10.008 18.9969 8.60058 18.4671 7.32154C17.9373 6.0425 17.04 4.94929 15.8889 4.18015C14.7378 3.41101 13.3844 3.00049 12 3.00049C10.6156 3.00049 9.26222 3.41101 8.11109 4.18015C6.95996 4.94929 6.06275 6.0425 5.53292 7.32154C5.00308 8.60058 4.86442 10.008 5.13445 11.3659C5.40449 12.7237 6.07111 13.971 7.05 14.95L12 19.9L16.95 14.95ZM12 14C10.9391 14 9.92172 13.5786 9.17158 12.8284C8.42143 12.0783 8 11.0609 8 9.99998C8 8.93912 8.42143 7.9217 9.17158 7.17156C9.92172 6.42141 10.9391 5.99999 12 5.99999C13.0609 5.99999 14.0783 6.42141 14.8284 7.17156C15.5786 7.9217 16 8.93912 16 9.99998C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14ZM12 12C12.5304 12 13.0391 11.7893 13.4142 11.4142C13.7893 11.0391 14 10.5304 14 9.99998C14 9.46955 13.7893 8.96084 13.4142 8.58577C13.0391 8.2107 12.5304 7.99999 12 7.99999C11.4696 7.99999 10.9609 8.2107 10.5858 8.58577C10.2107 8.96084 10 9.46955 10 9.99998C10 10.5304 10.2107 11.0391 10.5858 11.4142C10.9609 11.7893 11.4696 12 12 12Z"
                     
                    />
                  </svg>

                  <span>{{ address }}</span>
                </p>
              </div>
            </div>
            <div class="footer bg-gray-200 px-6 py-2 flex items-center justify-between">
                <button
                  class="inline-flex text-gray-700 font-semibold tracking-wide rounded items-center px-3 py-2  leading-tight bg-white shadow"
                  :class="[{'text-xs': isRtl}, {'text-sm': !isRtl}]"
                  @click="$emit('more')"
                >
                  <span>{{ $t('btn.more') }}</span>
                </button>
                <div class="rating inline-flex items-center text-sm ">
                  <svg class="text-yellow-500 fill-current" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.1 21.98C5.9344 22.0671 5.74768 22.106 5.56108 22.0922C5.37448 22.0785 5.19548 22.0126 5.04443 21.9022C4.89338 21.7918 4.77634 21.6412 4.70662 21.4676C4.63689 21.294 4.61728 21.1042 4.65 20.92L5.68 14.89L1.3 10.63C1.165 10.4996 1.06944 10.3338 1.02426 10.1515C0.979084 9.96932 0.986109 9.77807 1.04454 9.59966C1.10296 9.42125 1.21043 9.26289 1.35464 9.1427C1.49885 9.02251 1.67399 8.94534 1.86 8.92002L7.91 8.04002L10.61 2.56002C10.6919 2.39095 10.8197 2.24836 10.9789 2.14859C11.1381 2.04883 11.3221 1.99591 11.51 1.99591C11.6979 1.99591 11.8819 2.04883 12.0411 2.14859C12.2003 2.24836 12.3281 2.39095 12.41 2.56002L15.11 8.04002L21.17 8.92002C21.3532 8.94828 21.5248 9.02687 21.6659 9.14703C21.807 9.26719 21.9119 9.42419 21.969 9.60051C22.026 9.77682 22.0329 9.96552 21.989 10.1455C21.945 10.3256 21.8519 10.4898 21.72 10.62L17.34 14.89L18.38 20.92C18.4141 21.1056 18.395 21.297 18.325 21.4722C18.2549 21.6474 18.1367 21.7992 17.984 21.9101C17.8313 22.0209 17.6504 22.0863 17.4621 22.0987C17.2738 22.1111 17.0859 22.0699 16.92 21.98L11.52 19.13L6.1 21.98ZM11.05 17.11C11.1934 17.0347 11.353 16.9953 11.515 16.9953C11.677 16.9953 11.8366 17.0347 11.98 17.11L16.06 19.26L15.28 14.71C15.2538 14.5508 15.2664 14.3876 15.3169 14.2344C15.3674 14.0812 15.4543 13.9424 15.57 13.83L18.87 10.61L14.31 9.94002C14.149 9.91851 13.9956 9.8581 13.8632 9.76401C13.7308 9.66992 13.6233 9.54499 13.55 9.40002L11.51 5.26002L9.47 9.40002C9.39765 9.54372 9.29169 9.66785 9.16113 9.76186C9.03056 9.85587 8.87924 9.91698 8.72 9.94002L4.15 10.61L7.45 13.83C7.56753 13.9414 7.65624 14.0797 7.70849 14.233C7.76075 14.3863 7.77499 14.55 7.75 14.71L6.96 19.26L11.05 17.11Z"/>
                  </svg>
                  <span :class="[{'mr-1': isRtl}, {'ml-1': !isRtl}]">{{ rate }}</span>
                </div>
            </div> <!-- ./Footer -->
          </div>
</template>

<script>
import HeadLine from '@/components/theme/HeadLine';
import { mapGetters } from 'vuex';

export default {
    props: ['FullName', 'speciality', 'address', 'rate', 'avatar'],
    components: {HeadLine},
    computed: {
        ...mapGetters({
            isRtl: ['locale/IS_RTL']
        })
    }
}
</script>

<style>

</style>